import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const PortfolioSub = React.lazy(() =>
    import('../PortfolioSub')
);
const portfolioSubRoutesRegistry = [
    {
        path: PAGE_URL.PORTFOLIO_SUB_PAGE,
        element: <PortfolioSub />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default portfolioSubRoutesRegistry;
